import React from "react";
import { createRoot } from "react-dom/client";
import TechnicalSupportRequestIsland from "./TechnicalSupportRequestIsland";
import "react-datepicker/dist/react-datepicker.css";
import "./technicalSupportRequestIsland.css";

const mountNode = document.getElementById("technical-support-request-island");

if (mountNode) {
  const rawConfig = mountNode.getAttribute("data-config");

  if (rawConfig) {
    const config = JSON.parse(rawConfig);
    createRoot(mountNode).render(<TechnicalSupportRequestIsland config={config} />);
  }
}
